var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_1282)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.777832 2.16927C0.777832 1.87713 0.875288 1.63369 1.0702 1.43893C1.26511 1.24417 1.50875 1.14679 1.80112 1.14679H12.2289C12.5213 1.14679 12.7649 1.24417 12.9598 1.43893C13.1547 1.63369 13.2522 1.87713 13.2522 2.16927C13.2522 2.39648 13.1791 2.60747 13.0329 2.80223L8.96412 7.79286V11.2741C8.96412 11.4851 8.89103 11.6718 8.74484 11.8341C8.58242 11.9801 8.39563 12.0532 8.18447 12.0532C7.98956 12.0532 7.82714 11.9964 7.69719 11.8827L5.43135 10.1056C5.18771 9.89461 5.06589 9.63493 5.06589 9.32657V7.79286L0.997108 2.80223C0.850924 2.6237 0.777832 2.41271 0.777832 2.16927ZM2.11785 2.31533L6.11354 7.20859C6.19475 7.30597 6.23536 7.42769 6.23536 7.57376V9.22919L7.79465 10.4708V7.57376C7.79465 7.44392 7.83526 7.3222 7.91647 7.20859L11.9122 2.31533H2.11785Z",
    fill: "#6C757D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_1282"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.57,
    height: 13,
    fill: "white",
    transform: "matrix(1 0 0 -1 0.72998 13.1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableFilter);
export default __webpack_public_path__ + "static/media/table-filter.9191e9c14c2f70e08ab52b411cafca14.svg";
export { ForwardRef as ReactComponent };